import {
  OnlyIElementsStore,
  selectIElementsSlice,
} from "@/store/ielements-slice-selector";
import { curryAppSelector } from "@/store/reselect";
import {
  isIElementImg360,
  type IElementGenericOdometryPath,
} from "@faro-lotv/ielement-types";
import { selectChildrenDepthFirst } from "@faro-lotv/project-source";
import { createSelector } from "@reduxjs/toolkit";

/**
 *
 * @returns The list of 360s to render as waypoints of a video mode trajectory
 * @param store The current app store
 * @param path The path from which the list of panorama images should be extracted
 */
export const selectTrajectoryWaypointPanoramas = curryAppSelector(
  createSelector(
    [
      selectIElementsSlice,
      (store: OnlyIElementsStore, path: IElementGenericOdometryPath) => path,
    ],
    (iElements, path) =>
      selectChildrenDepthFirst(path, isIElementImg360)({ iElements }),
  ),
);
